import React, { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthProvider";
import Loading from "../../Shared/Loading/Loading";

const LoginStudentMobile = () => {
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();
  const { signIn } = useContext(AuthContext);
  const [loginError, setLoginError] = useState("");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (data) => {
    setLoginError("");
    setIsLoading(true);
    signIn(data.email, data.password)
      .then((result) => {
        const user = result.user;
        console.log(user);
        setIsLoading(false);
        navigate("/dashboardTwo/tutorDashboard");
      })
      .catch((error) => {
        console.error("Login error", error);
        switch (error.code) {
          case "auth/user-not-found":
            setLoginError("Email not found");
            break;
          case "auth/wrong-password":
            setLoginError("Incorrect password");
            break;
          default:
            setLoginError("Invalid email or password.");
            break;
        }
      })

      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <div className=" bg-gray-200 h-screen">
      <div className="titleShape bg-green-800 flex justify-center items-center">
        <h1 className="text-2xl font-bold text-white font-marcellus">
          Tutor Tree
        </h1>
      </div>
      <div className="m-5 p-5 rounded-xl bg-white mt-10">
      <h2 className="text-2xl text-center font-signika my-4">Student Log In</h2>

        <form onSubmit={handleSubmit(handleLogin)}>
          <div className="form-control w-full mt-5">
            <label className="label">
              {" "}
              <span className="text-xl font-signika text-green-900">Email</span>
            </label>
            <input
              type="text"
              {...register("email", {
                required: "Email Address is required",
              })}
              className="input border-2 border-green-400 input-bordered w-full focus:border-2 focus:border-orange-500"
            />
            {errors.email && (
              <p className="text-red-600">{errors.email?.message}</p>
            )}
          </div>
          <div className="form-control w-full mt-5">
            <label className="label">
              {" "}
              <span className="text-xl font-signika text-green-900">
                Password
              </span>
            </label>
            <input
              type="password"
              {...register("password", {
                required: "Password is required",
                minLength: {
                  value: 6,
                  message: "Password must be 6 characters or longer",
                },
              })}
              className="input border-2 border-green-400 input-bordered w-full focus:border-2 focus:border-orange-500"
            />

            {errors.password && (
              <p className="text-red-600">{errors.password?.message}</p>
            )}
          </div>
          {/* <input className='btn bg-indigo-700 w-full ' value="Login" type="submit" /> */}
          {isLoading ? (
            <div className="mt-5 bg-green-700 cursor-pointer hover:bg-green-900 duration-300 text-white font-jost text-xl py-2 w-full rounded-lg">
              <Loading></Loading>
            </div>
          ) : (
            <input
              className="mt-5 bg-green-700 cursor-pointer hover:bg-green-900 duration-300 text-white font-jost text-xl py-2 w-full rounded-lg"
              value="Login"
              type="submit"
            />
          )}
          <div>
            {loginError && <p className="text-red-600">{loginError}</p>}
          </div>
        </form>
        <div className="flex justify-between mt-5">
          <div>
          
              <Link className="text-md font-signika text-green-700" to="/signup">
                Sign Up
              </Link>

          </div>

          <div>
         
           
                <Link className="text-md font-signika text-green-700" to="/verifyStudents">Forget Password?</Link>
            
    
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginStudentMobile;
